import { Navigate, useNavigate } from 'react-router-dom';
import { useActiveOrganization } from '@repo/api-client/react';
import { useCreateInvoice } from '@repo/queries';
import { Page, PageHeader } from '@/features/common/PageHeader';
import { AiPill } from '@/features/ai/AiPill';
import { useAiComposer } from '@/features/ai/AiComposerContext';
import { InvoiceForm } from '@/features/invoice/InvoiceForm';
import { useToast } from '@/components/ui/use-toast';
import { describeAppError } from '@/features/common/describeAppError';
import { useActiveRole } from '@/features/auth/useActiveRole';

export function InvoiceCreateScreen() {
  const navigate = useNavigate();
  const { canEditOrg } = useActiveRole();
  const org = useActiveOrganization();
  const { createInvoice, loading } = useCreateInvoice();
  const { toast } = useToast();
  const { open: openAi } = useAiComposer();

  if (!canEditOrg) {
    return <Navigate to="/invoices" replace />;
  }

  return (
    <Page>
      <PageHeader
        title="New invoice"
        description="Fill in the details below."
      />

      <AiPill className="mb-5" onClick={() => openAi()} />

      <InvoiceForm
        defaultCurrency={org?.currency ?? 'USD'}
        loading={loading}
        submitLabel="Save draft"
        onCancel={() => navigate('/invoices')}
        onSubmit={async (payload) => {
          try {
            const created = await createInvoice(payload);
            toast({
              title: 'Draft created',
              description: `${created.invoiceNumber} saved as draft.`,
              variant: 'success',
            });
            navigate(`/invoices/${created.id}`);
          } catch (err) {
            const desc = describeAppError(err);
            toast({ title: desc.title, description: desc.message, variant: 'danger' });
          }
        }}
      />
    </Page>
  );
}
